
export const __t: (string: string) => string = (string: string) => {
    let lang = process.env.GATSBY_LANG;

    if (!['en-GB'].includes(lang) && lang?.includes('-')) {
        lang = lang.split('-')[0];
    }

    if (lang && lang !== 'en' && translates[lang] && translates[lang][string]) {
        return translates[lang][string];
    }

    return string;
}

const translates = {
    'en-GB': {
        "cart": "basket",
        "Cart": "Basket",
        "View cart": "View basket",
        "Your cart is currently empty!": "Your basket is currently empty!",
        "Looks like you have no items in your shopping cart.": "Looks like you have no items in your shopping basket.",
        "Return to cart": "Return to basket",
        "Add to cart": "Add to basket",
        "Your cart": "Your basket",
        "Your cart contains ": "Your basket contains ",
        "Apartment, suite, etc. (optional)": "Flat, suite, etc. (optional)",
    },
    'de': {
        "Canada": "Kanada",
        "Your cart": "Ihr Warenkorb",
        "Subtotal": "Zwischensumme",
        "Checkout": "Kasse",
        "View cart": "Warenkorb ansehen",
        "Remove": "Entfernen",
        "Quantity:": "Menge:",
        "Top sales": "Top-Verkäufe",
        "New collection": "Neue Kollektion",
        "Women's Asian Style Collection": "Damen Asien-Stil Kollektion",
        "Men's Asian Style Collection": "Herren Asien-Stil Kollektion",
        "Women's asian style collection": "Damen Asien-Stil Kollektion",
        "Men's asian style collection": "Herren Asien-Stil Kollektion",
        "About us": "Über uns",
        "Contacts": "Kontakt",
        "Search for kimono": "Suche nach Kimono",
        "Search": "Suche",
        "See all kimono": "Siehe alle Kimono",
        "Read more about our store": "Lesen Sie mehr über unser Geschäft",
        "In Other countries": "In anderen Ländern",
        "United States": "Vereinigte Staaten",
        "Germany": "Deutschland",
        "Sign Up For Exclusive Offers": "Melden Sie sich für exklusive Angebote an ",
        "You've successfully signed up for our exclusive offers!": "Sie haben sich erfolgreich für unsere exklusiven Angebote angemeldet!",
        "Unexpected error occurred! Please try again later.": "Unerwarteter Fehler aufgetreten! Bitte versuchen Sie es später noch einmal.",
        "Sign up for exclusive offers": "Melden Sie sich für exklusive Angebote an",
        "Enter your email": "Geben Sie Ihre E-Mail-Adresse ein",
        "Sign up": "Anmelden",
        "Customer service": "Kundenservice",
        "Information": "Informationen",
        "Show more": "Mehr anzeigen",
        "Sort by: ": "Sortieren nach: ",
        "Home": "Startseite",
        "Shop": "Laden",
        "Search results for": "Suchergebnisse für",
        "Showing": "Zeigend",
        "of": "von",
        "results": "Befund",
        "Popularity": "Popularität",
        "Average rating": "Durchschnittliche Bewertung",
        "Latest": "Neueste",
        "Price - low to high": "Preis - niedrig bis hoch",
        "Price - high to low": "Preis - hoch bis niedrig",
        "Add to cart": "In den Warenkorb",
        "Out of stock": "Nicht vorrätig",
        "Notes about your order, e.g. special notes for delivery.": "Notizen zu Ihrer Bestellung, z.B. spezielle Hinweise für die Lieferung.",
        "Shipping Information": "Versandinformationen",
        "Email me with news and offers": "Schicken Sie mir eine E-Mail mit Neuigkeiten und Angeboten",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Street address": "Straße",
        "Apartment, suite, etc. (optional)": "Appartement, Suite, etc. (wahlfrei)",
        "City": "Stadt",
        "Country / Region": "Land / Region",
        "State": "Staat",
        "Post Code / ZIP": "Postleitzahl / PLZ",
        "Phone": "Telefon",
        "Continue to payment": "Weiter zur Zahlung",
        "Return to cart": "Zurück in den Warenkorb",
        "Complete order": "Bestellung abschließen",
        "Return to information": "Zurück zu den Informationen",
        "Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our ": "Ihre personenbezogenen Daten werden verwendet, um Ihre Bestellung zu bearbeiten, Ihre Erfahrung auf dieser Website zu unterstützen und für andere Zwecke, die in unserem ",
        "privacy policy": "Datenschutzerklärung",
        "Billing Information": "Rechnungsinformationen",
        "Use a different billing address?": "Verwenden Sie eine andere Rechnungsadresse?",
        "An unexpected error occurred.": "Es ist ein unerwarteter Fehler aufgetreten.",
        "Unknown error": "Unbekannter Fehler",
        "Credit/Debit Card": "Kredit-/Debitkarte",
        "Pay with your credit card via Stripe.": "Bezahlen Sie mit Ihrer Kreditkarte über Stripe.",
        "Pay with your credit card.": "Bezahlen Sie mit Ihrer Kreditkarte.",
        "PayPal": "PayPal",
        "Pay via PayPal.": "Bezahlen Sie mit PayPal.",
        "I have read and agree to the website": "Ich habe die Website gelesen und stimme ihr zu",
        "terms and conditions": "Allgemeine Geschäftsbedingungen",
        "Coupon code": "Gutscheincode",
        "Apply code": "Code anwenden",
        "Your cart is currently empty!": "Ihr Warenkorb ist derzeit leer!",
        "Looks like you have no items in your shopping cart.": "Sieht so aus, als hätten Sie keine Artikel in Ihrem Warenkorb.",
        "Return to home page": "Zurück zur Startseite",
        "Cart": "Warenkorb",
        "Your cart contains ": "Ihr Warenkorb enthält ",
        "item": "Gegenstand",
        "items": "Gegenstände",
        "Continue shopping": "Weiter einkaufen",
        "Product": "Produkt",
        "Price": "Preis",
        "Quantity": "Menge",
        "Total": "Insgesamt",
        "Shipping": "Versand",
        "Color: ": "Farbe: ",
        "Size: ": "Größe: ",
        "NOTHING FOUND": "NICHTS GEFUNDEN",
        "No page found for this address": "Für diese Adresse wurde keine Seite gefunden",
        "Go home": "Geh nach Hause",
        "Not found": "Nicht gefunden",
        "Collection": "Kollektion",
        "search...": "suchen...",
        "Description": "Beschreibung",
        "Size chart": "Größentabelle",
        "Write review": "Bewertung schreiben",
        "Reviews": "Bewertungen",
        "Customer Reviews": "Kundenrezensionen",
        "out of 5": "von 5",
        "Based on": "Basierend auf",
        "reviews": "bewertungen",
        "Your review has been successfully submitted!": "Ihre Bewertung wurde erfolgreich abgegeben!",
        "Add a review": "Bewertung hinzufügen",
        "Your email address will not be published.": "Ihre E-Mail-Adresse wird nicht veröffentlicht.",
        "Required fields are marked": "Pflichtfelder sind markiert",
        "Your rating": "Ihre Bewertung",
        "Your review": "Ihre Bewertung",
        "Name": "Name",
        "Email": "E-Mail",
        "Submit": "Senden",
        "Verified Buyer": "Verifizierter Käufer",
        "Newest": "Neueste",
        "Highest rated": "Am höchsten bewertet",
        "Lowest rated": "Niedrigste Bewertung",
        "Oldest": "Älteste",
        "Color": "Farbe",
        "Size": "Größe",
        "You may also like": "Das könnte Ihnen auch gefallen",
        "Billing address": "Rechnungsadresse",
        "Shipping address": "Lieferadresse",
        "Order Number:": "Bestellnummer:",
        "Date": "Datum",
        "Payment method": "Zahlungsmethode",
        "Return to shop": "Zurück zum Shop",
        "Hide order summary": "Bestellübersicht ausblenden",
        "Show order summary": "Bestellübersicht anzeigen",
        "Payment": "Zahlung",
        "Our": "Unsere",
        "Goal": "Ziel",
        "is your beauty": "ist deine Schönheit",
        "We believe that everyone should have the opportunity to experience the elegance and beauty of a Japanese kimono. That's why we offer a wide range of styles and sizes to suit every taste and body type. Our mission is to provide our customers with the highest quality kimonos that showcase the exquisite craftsmanship and timeless elegance of traditional Japanese clothing.": "Wir sind der Meinung, dass jeder in der Lage sein sollte, die Schönheit und Raffinesse eines japanischen Kimonos zu genießen. Deshalb haben wir eine Vielzahl von Designs und Größen, die zu jeder Persönlichkeit und Körperform passen. Unser Ziel ist es, unseren Kunden die bestmöglichen Kimonos und andere japanisch inspirierte Produkte anzubieten, die die wunderbare Herstellung und klassische Schönheit der traditionellen japanischen Mode zeigen.",
        "No products were found matching your selection.": "Es wurden keine Produkte gefunden, die Ihrer Auswahl entsprechen.",
        "See all results": "Alle Ergebnisse anzeigen",
        "Express checkout": "Express-Kasse",
        "Or": "Oder",
        "Free": "Kostenlos",
        "Coupon": "Coupon",
        "is applied successfully.": "wird erfolgreich angewendet.",
        "Coupon applied successfully!": "Coupon erfolgreich angewendet!",
        "Coupon removed successfully!": "Coupon erfolgreich entfernt!",
        "Filters": "Filter",
        "Sort by": "Sortieren nach",
        "Invalid email": "Ungültige E-Mail",
        "Invalid ZIP code.": "Ungültige Postleitzahl ",
        "This value is required": "Dieser Wert ist erforderlich",
        "Must only contain digits 0 through 9.": "Darf nur die Ziffern 0 bis 9 enthalten.",
        "Thank you for your purchase": "Vielen Dank für Ihren Kauf",
        "Privacy Overview": "Überblick über den Datenschutz",
        "This website uses cookies to improve your experience while you navigate through the website. Out of these cookies, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing experience.": "Diese Website verwendet Cookies, um Ihre Navigation auf der Website zu verbessern. Von diesen Cookies werden die als notwendig eingestuften Cookies in Ihrem Browser gespeichert, da sie für das Funktionieren der Grundfunktionen der Website unerlässlich sind. Wir verwenden auch Cookies von Dritten, die uns helfen zu analysieren und zu verstehen, wie Sie diese Website nutzen. Diese Cookies werden nur mit Ihrer Zustimmung in Ihrem Browser gespeichert. Sie haben auch die Möglichkeit, diese Cookies abzulehnen. Das Ablehnen einiger dieser Cookies kann jedoch Auswirkungen auf Ihr Surfverhalten haben.",
        'NextRoll, Inc. ("NextRoll") and our advertising partners use cookies and similar technologies on this site and around the web to collect and use personal data (e.g., your IP address). If you consent, the cookies, device identifiers, or other information can be stored or accessed on your device for the purposes described below. You can click "Allow All" or "Decline All" or click Settings above to customize your consent.': "NextRoll Inc. („NextRoll“) und unsere Werbepartner verwenden Cookies und ähnliche Technologien auf dieser Website und im Internet, um persönliche Daten (z. B. Ihre IP-Adresse) zu sammeln und zu nutzen. Wenn Sie zustimmen, können die Cookies, Gerätekennungen oder andere Informationen auf Ihrem Gerät zu den unten beschriebenen Zwecken gespeichert oder abgerufen werden. Sie können auf „Alle Zulassen“ oder „Alle Ablehnen“ oder oben auf Einstellungen klicken, um Ihre Zustimmung anzupassen.",
        'NextRoll and our advertising partners process personal data to:<br>● Store and/or access information on a device;<br>● Create a personalized content profile;<br>● Select personalised content;<br>● Personalized ads, ad measurement and audience insights;<br>● Product development.<br>For some of the purposes above, our advertising partners:<br>● Use precise geolocation data.<br>Some of our partners rely on their legitimate business interests to process personal data. View our advertising partners to see the purposes they believe they have a legitimate interest for and how you can object to such processing.': "NextRoll und unsere Werbepartner verarbeiten personenbezogene Daten, um:<br>● Informationen auf einem Gerät zu speichern und/oder darauf zuzugreifen;<br>● ein personalisiertes Inhaltsprofil zu erstellen;<br>● personalisierte Inhalte auszuwählen;<br>● personalisierte Werbung anzuwenden, Werbemessung durchzuführen und Einblicke in die Zielgruppe zu gewinnen;<br>● die Produktentwicklung zu fördern.<br>Für einige der oben genannten Zwecke verwenden unsere Werbepartner:<br>● genaue Geolokalisierungsdaten.<br>Einige unserer Partner stützen sich auf ihre legitimen Geschäftsinteressen, um personenbezogene Daten zu verarbeiten. Sehen Sie sich unsere Werbepartner an, um zu erfahren, für welche Zwecke diese glauben, ein berechtigtes Interesse zu haben, und wie Sie einer solchen Verarbeitung widersprechen können.",
        "Your changes on this site will be applied across the internet on any digital property you visit using NextRoll's technology. If you select Decline All, you will still be able to view content on this site and you will still receive advertising, but the advertising will not be tailored for you. You may change your setting whenever you see": "Die von Ihnen auf dieser Website vorgenommenen Änderungen werden im gesamten Internet auf alle digitalen Objekte übertragen, die Sie mithilfe der Technologie von NextRoll aufrufen. Wenn Sie „Alle Ablehnen“ wählen, können Sie weiterhin Inhalte auf dieser Website ansehen und erhalten weiterhin Werbung, die jedoch nicht auf Sie zugeschnitten ist. Sie können Ihre Einstellung jederzeit ändern.",
        "Show less": "Weniger anzeigen",
        "Necessary": "Notwendig",
        "Preferences": "Präferenzen",
        "Statistics": "Statistik",
        "Marketing": "Marketing",
        "Always Enabled": "Immer Aktiviert",
        "Enabled": "Aktiviert",
        "Disabled": "Deaktiviert",
        "Save & accept": "SPEICHERN & ANNEHMEN",
        "Cookie settings": "Mehr erfahren",
        "Accept": "AKZEPTIEREN",
        "We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies.": "Diese Website verwendet Cookies, um Ihr Erlebnis zu verbessern. Wir gehen davon aus, dass Sie damit einverstanden sind, aber Sie können sich dagegen entscheiden, wenn Sie es wünschen.",
        "Necessary cookies are absolutely essential for the website to function properly. This category only includes cookies that ensures basic functionalities and security features of the website. These cookies do not store any personal information.": "Notwendige Cookies sind für das ordnungsgemäße Funktionieren der Website unbedingt erforderlich. Zu dieser Kategorie gehören nur Cookies, die grundlegende Funktionen und Sicherheitsmerkmale der Website gewährleisten. Diese Cookies speichern keine persönlichen Informationen.",
        "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.": "Präferenz-Cookies ermöglichen es einer Website, Informationen zu speichern, die das Verhalten oder Aussehen der Website verändern, wie z. B. Ihre bevorzugte Sprache oder die Region, in der Sie sich befinden.",
        "Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.": "Statistik-Cookies helfen Website-Betreibern zu verstehen, wie Besucher mit Websites interagieren, indem sie Informationen anonym sammeln und melden.",
        "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.": "Marketing-Cookies werden verwendet, um Besucher auf verschiedenen Websites zu verfolgen. Ziel ist es, Anzeigen zu schalten, die für den einzelnen Nutzer relevant und ansprechend sind und damit für Verlage und dritte Werbetreibende wertvoller sind.",
        "Only": "Nur noch",
        "left in stock": "Stück auf Lager",
        "Social": "Soziales",
        "United Kingdom": "Vereinigtes Königreich",
        "Switzerland": "Schweiz",
        "Ireland": "Irland",
        "New Zealand": "Neuseeland",
        "Austria": "Österreich",
        "France": "Frankreich",
        "Sweden": "Schweden",
        "The payment form is invalid": "Das Zahlungsformular ist ungültig",
        "Size Guide": "Größentabelle",
        "Japanese clothing": "Japanische Kleidung",
        "Accept all": "Alle akzeptieren",
        "We value your privacy": "Wir schätzen Ihre Privatsphäre",
        'We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking "Accept All", you consent to the use of ALL the cookies. However, you may visit "Cookie Settings" to provide a controlled consent.': 'Wir verwenden Cookies auf unserer Website, um Ihnen die bestmögliche Erfahrung zu bieten, indem wir Ihre Präferenzen und wiederholten Besuche speichern. Wenn Sie auf "Alle akzeptieren" klicken, erklären Sie sich mit der Verwendung ALLER Cookies einverstanden. Sie können jedoch die "Cookie-Einstellungen" besuchen, um eine kontrollierte Zustimmung zu erteilen.',
        'Cancel': 'Abbrechen',
    },
    'fr': {
        "Canada": "Canada",
        "Your cart": "Votre panier",
        "Subtotal": "Sous-total",
        "Checkout": "Commander",
        "View cart": "Voir le panier",
        "Remove": "Retirer",
        "Quantity:": "Quantité",
        "Top sales": "Meilleures ventes",
        "New collection": "Nouvelle collection",
        "Women's Asian Style Collection": "Collection Style Asiatique Femme",
        "Men's Asian Style Collection": "Collection Style Asiatique Homme",
        "Women's asian style collection": "Collection style asiatique femme",
        "Men's asian style collection": "Collection style asiatique homme",
        "About us": "A propos de nous",
        "Contacts": "Contacts",
        "Search for kimono": "Recherche de kimono",
        "Search": "Recherche",
        "See all kimono": "Voir tous les kimonos",
        "Read more about our store": "En savoir plus sur notre magasin",
        "In Other countries": "Dans les autres pays",
        "United States": "États-Unis",
        "Germany": "Allemagne",
        "Sign Up For Exclusive Offers": "S'inscrire aux offres exclusives",
        "You've successfully signed up for our exclusive offers!": "Vous vous êtes inscrit avec succès à nos offres exclusives !",
        "Unexpected error occurred! Please try again later.": "Une erreur inattendue s'est produite ! Veuillez réessayer plus tard.",
        "Sign up for exclusive offers": "S'inscrire aux offres exclusives",
        "Enter your email": "Entrez votre email",
        "Sign up": "S'inscrire",
        "Customer service": "Service clientèle",
        "Information": "Informations",
        "Show more": "Afficher plus",
        "Sort by: ": "Trier par",
        "Home": "Accueil",
        "Shop": "Boutique",
        "Search results for": "Résultats de la recherche pour",
        "Showing": "Affichage",
        "of": "de",
        "results": "résultats",
        "Popularity": "Popularité",
        "Average rating": "Note moyenne",
        "Latest": "Dernier",
        "Price - low to high": "Prix - du plus bas au plus haut",
        "Price - high to low": "Prix - du plus haut au plus bas",
        "Add to cart": "Ajouter au panier",
        "Out of stock": "En rupture de stock",
        "Notes about your order, e.g. special notes for delivery.": "Notes concernant votre commande, par exemple des notes spéciales pour la livraison",
        "Shipping Information": "Informations sur l'expédition",
        "Email me with news and offers": "Envoyez-moi par courriel des nouvelles et des offres",
        "First name": "Prénom",
        "Last name": "Nom de famille",
        "Street address": "Adresse",
        "Apartment, suite, etc. (optional)": "Appartement, suite, etc. (facultatif)",
        "City": "Ville",
        "Country / Region": "Pays / Région",
        "State": "État",
        "Post Code / ZIP": "Code postal",
        "Phone": "Téléphone",
        "Continue to payment": "Continuer le paiement",
        "Return to cart": "Retourner au panier",
        "Complete order": "Terminer la commande",
        "Return to information": "Retourner aux informations",
        "Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our ": "Vos données personnelles seront utilisées pour traiter votre commande, soutenir votre expérience sur ce site web et à d'autres fins décrites dans notre",
        "privacy policy": "politique de confidentialité",
        "Billing Information": "Informations de facturation",
        "Use a different billing address?": "Utiliser une autre adresse de facturation ?",
        "An unexpected error occurred.": "Une erreur inattendue s'est produite",
        "Unknown error": "Erreur inconnue",
        "Credit/Debit Card": "Carte de crédit/débit",
        "Pay with your credit card via Stripe.": "Payez avec votre carte de crédit via Stripe",
        "Pay with your credit card.": "Payez avec votre carte de crédit",
        "PayPal": "PayPal",
        "Pay via PayPal.": "Payez via PayPal.",
        "I have read and agree to the website": "J'ai lu et j'accepte le site web",
        "terms and conditions": "conditions générales",
        "Coupon code": "Coupon code",
        "Apply code": "Appliquer le code",
        "Your cart is currently empty!": "Votre panier est actuellement vide",
        "Looks like you have no items in your shopping cart.": "Il semble que vous n'ayez aucun article dans votre panier",
        "Return to home page": "Retour à la page d'accueil",
        "Cart": "Panier",
        "Your cart contains ": "Votre panier contient ",
        "item": "article",
        "items": "articles",
        "Continue shopping": "Poursuivre les achats",
        "Product": "Produit",
        "Price": "Prix",
        "Quantity": "Quantité",
        "Total": "Total",
        "Shipping": "Expédition",
        "Color: ": "Couleur",
        "Size: ": "Taille",
        "NOTHING FOUND": "RIEN TROUVÉ",
        "No page found for this address": "Aucune page trouvée pour cette adresse",
        "Go home": "Rentrer à la maison",
        "Not found": "Pas trouvé",
        "Collection": "Collection",
        "search...": "recherche...",
        "Description": "Description",
        "Size chart": "Tableau des tailles",
        "Write review": "Rédiger un commentaire",
        "Reviews": "Critiques",
        "Customer Reviews": "Avis des clients",
        "out of 5": "sur 5",
        "Based on": "Basé sur",
        "reviews": "critiques",
        "Your review has been successfully submitted!": "Votre commentaire a été soumis avec succès !",
        "Add a review": "Ajouter un avis",
        "Your email address will not be published.": "Votre adresse électronique ne sera pas publiée",
        "Required fields are marked": "Les champs obligatoires sont marqués",
        "Your rating": "Votre note",
        "Your review": "Votre avis",
        "Name": "Nom",
        "Email": "Email",
        "Submit": "Soumettre",
        "Verified Buyer": "Acheteur vérifié",
        "Newest": "Le plus récent",
        "Highest rated": "Le mieux noté",
        "Lowest rated": "Le moins bien noté",
        "Oldest": "Le plus ancien",
        "Color": "Couleur",
        "Size": "Taille",
        "You may also like": "Vous aimerez peut-être aussi",
        "Billing address": "Adresse de facturation",
        "Shipping address": "Adresse de livraison",
        "Order Number:": "Numéro de commande",
        "Date": "Date",
        "Payment method": "Mode de paiement",
        "Return to shop": "Retour à la boutique",
        "Hide order summary": "Masquer le résumé de la commande",
        "Show order summary": "Afficher le résumé de la commande",
        "Payment": "Paiement",
        "Our": "Notre",
        "Goal": "But",
        "is your beauty": "est votre beauté",
        "We believe that everyone should have the opportunity to experience the elegance and beauty of a Japanese kimono. That's why we offer a wide range of styles and sizes to suit every taste and body type. Our mission is to provide our customers with the highest quality kimonos that showcase the exquisite craftsmanship and timeless elegance of traditional Japanese clothing.": "Nous pensons que tout le monde devrait avoir la possibilité de découvrir l'élégance et la beauté d'un kimono japonais. C'est pourquoi nous proposons une large gamme de styles et de tailles pour répondre à tous les goûts et à toutes les morphologies. Notre mission est de fournir à nos clients des kimonos de la plus haute qualité qui mettent en valeur le savoir-faire exquis et l'élégance intemporelle des vêtements japonais traditionnels.",
        "No products were found matching your selection.": "Aucun produit correspondant à votre sélection n'a été trouvé",
        "See all results": "Voir tous les résultats",
        "Express checkout": "Paiement express",
        "Or": "Ou",
        "Free": "Gratuit",
        "Coupon": "Coupon",
        "is applied successfully.": "est appliqué avec succès",
        "Coupon applied successfully!": "Coupon appliqué avec succès !",
        "Coupon removed successfully!": "Coupon supprimé avec succès !",
        "Filters": "Filtres",
        "Sort by": "Trier par",
        "Invalid email": "Courriel invalide",
        "Invalid ZIP code.": "Code postal non valide",
        "This value is required": "Cette valeur est obligatoire",
        "Must only contain digits 0 through 9.": "Doit contenir uniquement les chiffres de 0 à 9",
        "Thank you for your purchase": "Merci pour votre achat",
        "Privacy Overview": "Aperçu de la protection de la vie privée",
        "This website uses cookies to improve your experience while you navigate through the website. Out of these cookies, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing experience.": "Ce site web utilise des cookies pour améliorer votre expérience lorsque vous naviguez sur le site web. Parmi ces cookies, ceux qui sont considérés comme nécessaires sont stockés sur votre navigateur, car ils sont essentiels au fonctionnement des fonctionnalités de base du site web. Nous utilisons également des cookies de tiers qui nous aident à analyser et à comprendre la manière dont vous utilisez ce site web. Ces cookies ne seront stockés dans votre navigateur qu'avec votre consentement. Vous avez également la possibilité de refuser ces cookies. Cependant, la désactivation de certains de ces cookies peut avoir un effet sur votre expérience de navigation.",
        'NextRoll, Inc. ("NextRoll") and our advertising partners use cookies and similar technologies on this site and around the web to collect and use personal data (e.g., your IP address). If you consent, the cookies, device identifiers, or other information can be stored or accessed on your device for the purposes described below. You can click "Allow All" or "Decline All" or click Settings above to customize your consent.': "NextRoll, Inc. (« NextRoll ») et nos partenaires publicitaires utilisent des cookies et des technologies similaires sur ce site et sur le web pour collecter et utiliser des données personnelles (par exemple, votre adresse IP). Si vous y consentez, les cookies, les identificateurs d'appareil ou d'autres informations peuvent être stockés ou consultés sur votre appareil aux fins décrites ci-dessous. Vous pouvez cliquer sur « Autoriser tout » ou « Refuser tout » ou cliquer sur Paramètres ci-dessus pour personnaliser votre consentement.",
        'NextRoll and our advertising partners process personal data to:<br>● Store and/or access information on a device;<br>● Create a personalized content profile;<br>● Select personalised content;<br>● Personalized ads, ad measurement and audience insights;<br>● Product development.<br>For some of the purposes above, our advertising partners:<br>● Use precise geolocation data.<br>Some of our partners rely on their legitimate business interests to process personal data. View our advertising partners to see the purposes they believe they have a legitimate interest for and how you can object to such processing.': "NextRoll et nos partenaires publicitaires traitent les données personnelles pour :<br>● Stocker et/ou accéder à des informations sur un appareil ;<br>● Créer un profil de contenu personnalisé ;<br>● Sélectionner un contenu personnalisé ;<br>● Annonces personnalisées, mesure des annonces et aperçu de l'audience ;<br>● Développement de produits.<br>Pour certaines des finalités ci-dessus, nos partenaires publicitaires :<br>● Utilisent des données de géolocalisation précises.<br>Certains de nos partenaires s'appuient sur leurs intérêts commerciaux légitimes pour traiter les données personnelles. Consultez nos partenaires publicitaires pour voir les finalités pour lesquelles ils estiment avoir un intérêt légitime et comment vous pouvez vous opposer à ce traitement.",
        "Your changes on this site will be applied across the internet on any digital property you visit using NextRoll's technology. If you select Decline All, you will still be able to view content on this site and you will still receive advertising, but the advertising will not be tailored for you. You may change your setting whenever you see": "Vos modifications sur ce site seront appliquées à travers l'internet sur toute propriété numérique que vous visitez en utilisant la technologie de NextRoll. Si vous choisissez de tout refuser, vous pourrez toujours consulter le contenu de ce site et vous recevrez toujours de la publicité, mais celle-ci ne sera pas adaptée à vos besoins. Vous pouvez modifier vos paramètres à tout moment",
        "Show less": "Montrer moins",
        "Necessary": "Nécessaire",
        "Preferences": "Préférences",
        "Statistics": "Statistiques",
        "Marketing": "Marketing",
        "Always Enabled": "Toujours activé",
        "Enabled": "Activé",
        "Disabled": "Désactivé",
        "Save & accept": "Enregistrer et accepter",
        "Cookie settings": "Paramètres des cookies",
        "Accept": "Accepter",
        "We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies.": "Nous utilisons des cookies sur notre site web pour vous offrir l'expérience la plus pertinente en mémorisant vos préférences et vos visites répétées. En cliquant sur « Accepter », vous consentez à l'utilisation de TOUS les cookies",
        "Necessary cookies are absolutely essential for the website to function properly. This category only includes cookies that ensures basic functionalities and security features of the website. These cookies do not store any personal information.": "Les cookies nécessaires sont absolument indispensables au bon fonctionnement du site web. Cette catégorie comprend uniquement les cookies qui garantissent les fonctionnalités de base et les caractéristiques de sécurité du site web. Ces cookies ne stockent aucune information personnelle.",
        "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.": "Les cookies de préférence permettent à un site web de se souvenir d'informations qui modifient le comportement ou l'apparence du site, comme votre langue préférée ou la région dans laquelle vous vous trouvez.",
        "Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.": "Les cookies statistiques aident les propriétaires de sites web à comprendre comment les visiteurs interagissent avec les sites web en collectant et en rapportant des informations de manière anonyme.",
        "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.": "Les cookies de marketing sont utilisés pour suivre les visiteurs sur les sites web. L'objectif est d'afficher des publicités pertinentes et attrayantes pour l'utilisateur individuel et, par conséquent, plus intéressantes pour les éditeurs et les annonceurs tiers.",

        "Only": "Seulement",
        "left in stock": "en stock",
        "Social": "Social",
        "United Kingdom": "Royaume-Uni",
        "Switzerland": "Suisse",
        "Ireland": "Irlande",
        "New Zealand": "Nouvelle-Zélande",
        "Austria": "Autriche",
        "France": "France",
        "Sweden": "Suède",
        "The payment form is invalid": "Le formulaire de paiement n'est pas valide",
        "Size Guide": "Tableau des tailles",
        "Japanese clothing": "Vêtements japonais",
        "Accept all": "Accepter tout",
        "We value your privacy": "Nous respectons votre vie privée",
        'We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking "Accept All", you consent to the use of ALL the cookies. However, you may visit "Cookie Settings" to provide a controlled consent.': `Nous utilisons des cookies sur notre site web pour vous offrir l'expérience la plus pertinente en mémorisant vos préférences et vos visites répétées. En cliquant sur "Accepter tout", vous consentez à l'utilisation de TOUS les cookies. Toutefois, vous pouvez visiter la section "Paramètres des cookies" pour donner un consentement contrôlé.`,
        'Cancel': 'Annuler',
    },
    'sv': {
        "Canada": "Kanada",
        "Your cart": "Din kundvagn",
        "Subtotal": "Subtotal",
        "Checkout": "Kassan",
        "View cart": "Visa kundvagn",
        "Remove": "Ta bort",
        "Quantity:": "Kvantitet:",
        "Top sales": "Toppförsäljning",
        "New collection": "Ny kollektion",
        "Women's Asian Style Collection": "Dam Asiatisk Stil Kollektion",
        "Men's Asian Style Collection": "Herr Asiatisk Stil Kollektion",
        "Women's asian style collection": "Dam asiatisk stil kollektion",
        "Men's asian style collection": "Herr asiatisk stil kollektion",
        "About us": "Om oss",
        "Contacts": "Kontakter",
        "Search for kimono": "Sök efter kimono",
        "Search": "Sökning",
        "See all kimono": "Se alla kimono",
        "Read more about our store": "Läs mer om vår butik",
        "In Other countries": "I andra länder",
        "United States": "Förenta Staterna",
        "Germany": "Tyskland",
        "Sign Up For Exclusive Offers": "Registrera dig för exklusiva erbjudanden",
        "You've successfully signed up for our exclusive offers!": "Du har framgångsrikt registrerat dig för våra exklusiva erbjudanden!",
        "Unexpected error occurred! Please try again later.": "Ett oväntat fel inträffade! Vänligen försök igen senare.",
        "Sign up for exclusive offers": "Registrera dig för exklusiva erbjudanden",
        "Enter your email": "Ange din e-postadress",
        "Sign up": "Registrera dig",
        "Customer service": "Kundtjänst",
        "Information": "Information",
        "Show more": "Visa mer",
        "Sort by: ": "Sortera efter: ",
        "Home": "Hem",
        "Shop": "Butik",
        "Search results for": "Sökresultat för",
        "Showing": "Showing",
        "of": "av",
        "results": "resultat",
        "Popularity": "Popularitet",
        "Average rating": "Genomsnittligt betyg",
        "Latest": "Senaste",
        "Price - low to high": "Pris - lågt till högt",
        "Price - high to low": "Pris - högt till lågt",
        "Add to cart": "Lägg till i varukorgen",
        "Out of stock": "Ut ur lager",
        "Notes about your order, e.g. special notes for delivery.": "Anteckningar om din beställning, t.ex. särskilda anteckningar för leverans.",
        "Shipping Information": "Sändningsinformation",
        "Email me with news and offers": "Emaila mig med nyheter och erbjudanden",
        "First name": "Förnamn",
        "Last name": "Efternamn",
        "Street address": "Gatuadress",
        "Apartment, suite, etc. (optional)": "Lägenhet, svit, etc. (valfritt)",
        "City": "Stad",
        "Country / Region": "Land / Region",
        "State": "Stat",
        "Post Code / ZIP": "Postnummer / ZIP",
        "Phone": "Telefon",
        "Continue to payment": "Fortsätt till betalning",
        "Return to cart": "Återvänd till kundvagn",
        "Complete order": "Komplettera beställning",
        "Return to information": "Återvänd till information",
        "Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our ": "Dina personuppgifter kommer att användas för att behandla din beställning, stödja din upplevelse på hela denna webbplats och för andra ändamål som beskrivs i vår ",
        "privacy policy": "integritetspolicy",
        "Billing Information": "Faktureringsinformation",
        "Use a different billing address?": "Använder du en annan faktureringsadress?",
        "An unexpected error occurred.": "Ett oväntat fel inträffade.",
        "Unknown error": "Okänt fel",
        "Credit/Debit Card": "Kredit-/Debetkort",
        "Pay with your credit card via Stripe.": "Betala med ditt kreditkort via Stripe.",
        "Pay with your credit card.": "Betala med ditt kreditkort.",
        "PayPal": "PayPal",
        "Pay via PayPal.": "Betala via PayPal.",
        "I have read and agree to the website": "Jag har läst och godkänner webbplatsens",
        "terms and conditions": "villkor och bestämmelser",
        "Coupon code": "Kupongkod",
        "Apply code": "Använd kod",
        "Your cart is currently empty!": "Din kundvagn är för närvarande tom!",
        "Looks like you have no items in your shopping cart.": "Det ser ut som om du inte har några varor i din kundvagn.",
        "Return to home page": "Återvänd till startsidan",
        "Cart": "Korg",
        "Your cart contains ": "Din kundvagn innehåller",
        "item": "artiklar",
        "items": "artiklar",
        "Continue shopping": "Fortsätt shoppa",
        "Product": "Produkt",
        "Price": "Pris",
        "Quantity": "Kvantitet",
        "Total": "Totalt",
        "Shipping": "Sändning",
        "Color: ": "Färg: ",
        "Size: ": "Storlek: ",
        "NOTHING FOUND": "INGET HITTAT",
        "No page found for this address": "Ingen sida hittades för denna adress",
        "Go home": "Gå hem",
        "Not found": "Inte hittad",
        "Collection": "Samling",
        "search...": "sök...",
        "Description": "Beskrivning",
        "Size chart": "Storlekstabell",
        "Write review": "Skriv recension",
        "Reviews": "Revy",
        "Customer Reviews": "Kundernas recensioner",
        "out of 5": "Utav 5",
        "Based on": "Baserat på",
        "reviews": "recensioner",
        "Your review has been successfully submitted!": "Din recension har skickats in framgångsrikt!",
        "Add a review": "Lägg till en recension",
        "Your email address will not be published.": "Din e-postadress kommer inte att publiceras.",
        "Required fields are marked": "Nödvändiga fält är markerade",
        "Your rating": "Ditt betyg",
        "Your review": "Din recension",
        "Name": "Namn",
        "Email": "E-post",
        "Submit": "Sänd in",
        "Verified Buyer": "Verifierad köpare",
        "Newest": "Nyaste",
        "Highest rated": "Högst rankad",
        "Lowest rated": "Lågsta betyg",
        "Oldest": "Äldst",
        "Color": "Färg",
        "Size": "Storlek",
        "You may also like": "Du kanske också gillar",
        "Billing address": "Faktureringsadress",
        "Shipping address": "Leveransadress",
        "Order Number:": "Beställningsnummer:",
        "Date": "Datum",
        "Payment method": "Betalningsmetod",
        "Return to shop": "Återvänd till butik",
        "Hide order summary": "Dölj orderöversikt",
        "Show order summary": "Visa orderöversikt",
        "Payment": "Betalning",
        "Our": "Vårt",
        "Goal": "Mål",
        "is your beauty": "är din skönhet",
        "We believe that everyone should have the opportunity to experience the elegance and beauty of a Japanese kimono. That's why we offer a wide range of styles and sizes to suit every taste and body type. Our mission is to provide our customers with the highest quality kimonos that showcase the exquisite craftsmanship and timeless elegance of traditional Japanese clothing.": "Vi anser att alla ska ha möjlighet att uppleva elegansen och skönheten i en japansk kimono. Det är därför vi erbjuder ett brett utbud av stilar och storlekar som passar alla smaker och kroppstyper. Vårt uppdrag är att förse våra kunder med kimonos av högsta kvalitet som visar upp det utsökta hantverket och den tidlösa elegansen i traditionella japanska kläder.",
        "No products were found matching your selection.": "Inga produkter hittades som matchade ditt val.",
        "See all results": "Se alla resultat",
        "Express checkout": "Express utcheckning",
        "Or": "Eller",
        "Free": "Gratis",
        "Coupon": "Kupong",
        "is applied successfully.": "är tillämpad framgångsrikt.",
        "Coupon applied successfully!": "Kupong tillämpas framgångsrikt!",
        "Coupon removed successfully!": "Kupongen togs bort framgångsrikt!",
        "Filters": "Filter",
        "Sort by": "Sortera efter",
        "Invalid email": "Ogiltig e-post",
        "Invalid ZIP code.": "Ogiltigt postnummer.",
        "This value is required": "Detta värde är obligatoriskt",
        "Must only contain digits 0 through 9.": "Måste endast innehålla siffrorna 0 till 9.",
        "Thank you for your purchase": "Tack för ditt köp",
        "Privacy Overview": "Översikt över sekretess",
        "This website uses cookies to improve your experience while you navigate through the website. Out of these cookies, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing experience.": "Den här webbplatsen använder cookies för att förbättra din upplevelse när du navigerar genom webbplatsen. Av dessa cookies lagras de cookies som kategoriseras som nödvändiga i din webbläsare eftersom de är nödvändiga för att grundläggande funktioner på webbplatsen ska fungera. Vi använder även tredjepartscookies som hjälper oss att analysera och förstå hur du använder webbplatsen. Dessa cookies lagras i din webbläsare endast med ditt samtycke. Du har också möjlighet att välja bort dessa cookies. Men om du väljer bort vissa av dessa cookies kan det påverka din surfupplevelse.",
        'NextRoll, Inc. ("NextRoll") and our advertising partners use cookies and similar technologies on this site and around the web to collect and use personal data (e.g., your IP address). If you consent, the cookies, device identifiers, or other information can be stored or accessed on your device for the purposes described below. You can click "Allow All" or "Decline All" or click Settings above to customize your consent.': "NextRoll, Inc. (/NextRoll/) och våra reklampartners använder cookies och liknande tekniker på denna webbplats och runt om på webben för att samla in och använda personuppgifter (t.ex. din IP-adress). Om du samtycker kan cookies, enhetsidentifierare eller annan information lagras eller nås på din enhet för de ändamål som beskrivs nedan. Du kan klicka på /Tillåt alla/ eller /Nedgång Alla/ eller klicka på Settings ovan för att anpassa ditt samtycke.",
        'NextRoll and our advertising partners process personal data to:<br>● Store and/or access information on a device;<br>● Create a personalized content profile;<br>● Select personalised content;<br>● Personalized ads, ad measurement and audience insights;<br>● Product development.<br>For some of the purposes above, our advertising partners:<br>● Use precise geolocation data.<br>Some of our partners rely on their legitimate business interests to process personal data. View our advertising partners to see the purposes they believe they have a legitimate interest for and how you can object to such processing.': "NextRoll och våra reklampartners behandlar personuppgifter för att:<br>● lagra och/eller komma åt information på en enhet;<br>● skapa en personlig innehållsprofil;<br>● välja personligt innehåll;<br>● personliga annonser, annonsmätning och publikinsikter;<br>● produktutveckling.<br>För några av syftena ovan använder våra reklampartners:<br>● exakta geolokaliseringsdata.<br>Vissa av våra partners förlitar sig på sina legitima affärsintressen för att behandla personuppgifter. Se våra reklampartners för att se vilka syften de anser sig ha ett legitimt intresse för och hur du kan invända mot sådan behandling.",
        "Your changes on this site will be applied across the internet on any digital property you visit using NextRoll's technology. If you select Decline All, you will still be able to view content on this site and you will still receive advertising, but the advertising will not be tailored for you. You may change your setting whenever you see": "Dina ändringar på den här webbplatsen kommer att tillämpas över hela internet på alla digitala fastigheter du besöker med hjälp av NextRolls teknik. Om du väljer Avböj allt kommer du fortfarande att kunna se innehåll på den här webbplatsen och du kommer fortfarande att få reklam, men reklamen kommer inte att skräddarsys för dig. Du kan ändra din inställning när som helst när du ser",
        "Show less": "Visa mindre",
        "Necessary": "Nödvändigt",
        "Preferences": "Inställningar",
        "Statistics": "Statistik",
        "Marketing": "Marknadsföring",
        "Always Enabled": "Alltid aktiverad",
        "Enabled": "Aktiverad",
        "Disabled": "Avaktiverad",
        "Save & accept": "Spara och acceptera",
        "Cookie settings": "Cookie-inställningar",
        "Accept": "Acceptera",
        "We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies.": "Vi använder cookies på vår webbplats för att ge dig den mest relevanta upplevelsen genom att komma ihåg dina preferenser och upprepade besök. Genom att klicka på ”Acceptera” samtycker du till användningen av ALLA cookies.",
        "Necessary cookies are absolutely essential for the website to function properly. This category only includes cookies that ensures basic functionalities and security features of the website. These cookies do not store any personal information.": "Nödvändiga cookies är absolut nödvändiga för att webbplatsen ska fungera korrekt. Den här kategorin omfattar endast cookies som säkerställer grundläggande funktioner och säkerhetsfunktioner på webbplatsen. Dessa cookies lagrar inte någon personlig information.",
        "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.": "Preferenscookies gör det möjligt för en webbplats att komma ihåg information som ändrar hur webbplatsen beter sig eller ser ut, t.ex. vilket språk du föredrar eller vilken region du befinner dig i.",
        "Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.": "Statistiska cookies hjälper webbplatsägare att förstå hur besökare interagerar med webbplatser genom att samla in och rapportera information anonymt.",
        "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.": "Marknadsföringscookies används för att spåra besökare på olika webbplatser. Avsikten är att visa annonser som är relevanta och engagerande för den enskilda användaren och därmed mer värdefulla för utgivare och tredjepartsannonsörer.",
        "Only": "Enbart",
        "left in stock": "Lämnat i lager",
        "Social": "Sociala",
        "United Kingdom": "Förenade Kungariket",
        "Switzerland": "Schweiz",
        "Ireland": "Irland",
        "New Zealand": "Nya Zeeland",
        "Austria": "Österrike",
        "France": "Frankrike",
        "Sweden": "Sverige",
        "The payment form is invalid": "Betalningsformuläret är ogiltigt",
        "Size Guide": "Storleksguide",
        "Japanese clothing": "Japanska kläder",
        "Accept all": "Acceptera alla",
        "We value your privacy": "Vi värdesätter din integritet",
        'We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking "Accept All", you consent to the use of ALL the cookies. However, you may visit "Cookie Settings" to provide a controlled consent.': 'Vi använder cookies på vår webbplats för att ge dig den mest relevanta upplevelsen genom att komma ihåg dina preferenser och upprepade besök. Genom att klicka på "Acceptera alla" samtycker du till användningen av ALLA cookies. Du kan dock besöka "Cookie-inställningar" för att ge ett kontrollerat samtycke.',
        'Cancel': 'Avbryt',
    },
    // 'temp': {
    //     "Canada": "",
    //     "Your cart": "",
    //     "Subtotal": "",
    //     "Checkout": "",
    //     "View cart": "",
    //     "Remove": "",
    //     "Quantity:": "",
    //     "Top sales": "",
    //     "New collection": "",
    //     "Women's Asian Style Collection": "",
    //     "Men's Asian Style Collection": "",
    //     "Women's asian style collection": "",
    //     "Men's asian style collection": "",
    //     "About us": "",
    //     "Contacts": "",
    //     "Search for kimono": "",
    //     "Search": "",
    //     "See all kimono": "",
    //     "Read more about our store": "",
    //     "In Other countries": "",
    //     "United States": "",
    //     "Germany": "",
    //     "Sign Up For Exclusive Offers": "",
    //     "You've successfully signed up for our exclusive offers!": "",
    //     "Unexpected error occurred! Please try again later.": "",
    //     "Sign up for exclusive offers": "",
    //     "Enter your email": "",
    //     "Sign up": "",
    //     "Customer service": "",
    //     "Information": "",
    //     "Show more": "",
    //     "Sort by: ": "",
    //     "Home": "",
    //     "Shop": "",
    //     "Search results for": "",
    //     "Showing": "",
    //     "of": "",
    //     "results": "",
    //     "Popularity": "",
    //     "Average rating": "",
    //     "Latest": "",
    //     "Price - low to high": "",
    //     "Price - high to low": "",
    //     "Add to cart": "",
    //     "Out of stock": "",
    //     "Notes about your order, e.g. special notes for delivery.": "",
    //     "Shipping Information": "",
    //     "Email me with news and offers": "",
    //     "First name": "",
    //     "Last name": "",
    //     "Street address": "",
    //     "Apartment, suite, etc. (optional)": "",
    //     "City": "",
    //     "Country / Region": "",
    //     "State": "",
    //     "Post Code / ZIP": "",
    //     "Phone": "",
    //     "Continue to payment": "",
    //     "Return to cart": "",
    //     "Complete order": "",
    //     "Return to information": "",
    //     "Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our ": "",
    //     "privacy policy": "",
    //     "Billing Information": "",
    //     "Use a different billing address?": "",
    //     "An unexpected error occurred.": "",
    //     "Unknown error": "",
    //     "Credit/Debit Card": "",
    //     "Pay with your credit card via Stripe.": "",
    //     "Pay with your credit card.": "",
    //     "PayPal": "",
    //     "Pay via PayPal.": "",
    //     "I have read and agree to the website": "",
    //     "terms and conditions": "",
    //     "Coupon code": "",
    //     "Apply code": "",
    //     "Your cart is currently empty!": "",
    //     "Looks like you have no items in your shopping cart.": "",
    //     "Return to home page": "",
    //     "Cart": "",
    //     "Your cart contains ": "",
    //     "item": "",
    //     "items": "",
    //     "Continue shopping": "",
    //     "Product": "",
    //     "Price": "",
    //     "Quantity": "",
    //     "Total": "",
    //     "Shipping": "",
    //     "Color: ": "",
    //     "Size: ": "",
    //     "NOTHING FOUND": "",
    //     "No page found for this address": "",
    //     "Go home": "",
    //     "Not found": "",
    //     "Collection": "",
    //     "search...": "",
    //     "Description": "",
    //     "Size chart": "",
    //     "Write review": "",
    //     "Reviews": "",
    //     "Customer Reviews": "",
    //     "out of 5": "",
    //     "Based on": "",
    //     "reviews": "",
    //     "Your review has been successfully submitted!": "",
    //     "Add a review": "",
    //     "Your email address will not be published.": "",
    //     "Required fields are marked": "",
    //     "Your rating": "",
    //     "Your review": "",
    //     "Name": "",
    //     "Email": "",
    //     "Submit": "",
    //     "Verified Buyer": "",
    //     "Newest": "",
    //     "Highest rated": "",
    //     "Lowest rated": "",
    //     "Oldest": "",
    //     "Color": "",
    //     "Size": "",
    //     "You may also like": "",
    //     "Billing address": "",
    //     "Shipping address": "",
    //     "Order Number:": "",
    //     "Date": "",
    //     "Payment method": "",
    //     "Return to shop": "",
    //     "Hide order summary": "",
    //     "Show order summary": "",
    //     "Payment": "",
    //     "Our": "",
    //     "Goal": "",
    //     "is your beauty": "",
    //     "We believe that everyone should have the opportunity to experience the elegance and beauty of a Japanese kimono. That's why we offer a wide range of styles and sizes to suit every taste and body type. Our mission is to provide our customers with the highest quality kimonos that showcase the exquisite craftsmanship and timeless elegance of traditional Japanese clothing.": "",
    //     "No products were found matching your selection.": "",
    //     "See all results": "",
    //     "Express checkout": "",
    //     "Or": "",
    //     "Free": "",
    //     "Coupon": "",
    //     "is applied successfully.": "",
    //     "Coupon applied successfully!": "",
    //     "Coupon removed successfully!": "",
    //     "Filters": "",
    //     "Sort by": "",
    //     "Invalid email": "",
    //     "Invalid ZIP code.": "",
    //     "This value is required": "",
    //     "Must only contain digits 0 through 9.": "",
    //     "Thank you for your purchase": "",
    //     "Privacy Overview": "",
    //     "This website uses cookies to improve your experience while you navigate through the website. Out of these cookies, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing experience.": "",
    //     'NextRoll, Inc. ("NextRoll") and our advertising partners use cookies and similar technologies on this site and around the web to collect and use personal data (e.g., your IP address). If you consent, the cookies, device identifiers, or other information can be stored or accessed on your device for the purposes described below. You can click "Allow All" or "Decline All" or click Settings above to customize your consent.': "",
    //     'NextRoll and our advertising partners process personal data to: ● Store and/or access information on a device; ● Create a personalized content profile; ● Select personalised content; ● Personalized ads, ad measurement and audience insights; ● Product development. For some of the purposes above, our advertising partners: ● Use precise geolocation data. Some of our partners rely on their legitimate business interests to process personal data. View our advertising partners to see the purposes they believe they have a legitimate interest for and how you can object to such processing.': "",
    //     "Your changes on this site will be applied across the internet on any digital property you visit using NextRoll's technology. If you select Decline All, you will still be able to view content on this site and you will still receive advertising, but the advertising will not be tailored for you. You may change your setting whenever you see": "",
    //     "Show less": "",
    //     "Necessary": "",
    //     "Preferences": "",
    //     "Statistics": "",
    //     "Marketing": "",
    //     "Always Enabled": "",
    //     "Enabled": "",
    //     "Disabled": "",
    //     "Save & accept": "",
    //     "Cookie settings": "",
    //     "Accept": "",
    //     "We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies.": "",
    //     "Necessary cookies are absolutely essential for the website to function properly. This category only includes cookies that ensures basic functionalities and security features of the website. These cookies do not store any personal information.": "",
    //     "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.": "",
    //     "Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.": "",
    //     "Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.": "",

    //     "Only": "",
    //     "left in stock": "",
    //     "Social": "",
    //     "United Kingdom": "",
    //     "Switzerland": "",
    //     "Ireland": "",
    //     "New Zealand": "",
    //     "Austria": "",
    //     "France": "",
    //     "Sweden": "",
    //     "The payment form is invalid": "",
    // "Size Guide": "",
    // "Japanese clothing":"",
    // "Accept all":"",
    // "We value your privacy":"",
    // 'We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking "Accept All", you consent to the use of ALL the cookies. However, you may visit "Cookie Settings" to provide a controlled consent.':"",
    // 'Cancel':'',
    // },
}
